'use client'

import { Table } from '@tanstack/react-table'
import { Input } from '@/components/ui/input'
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options'
import { useTranslation } from 'react-i18next'
import { debounceAsync } from '@/utils/debounce'
import { AdversaryTableParams } from '@/api/case'

interface DataTableToolbarProps<TData> {
    table: Table<TData>
    params: AdversaryTableParams
    setParams: React.Dispatch<React.SetStateAction<AdversaryTableParams>>
}

export function DataTableToolbar<TData>({
    table,
    params,
    setParams,
}: DataTableToolbarProps<TData>) {
    const { t } = useTranslation()

    const search = debounceAsync(async (value: string) => {
        setParams({ ...params, search: value === "" ? null : value, page: 0 });
    }, 500);

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        search(event.target.value);
    };

    return (
        <div className='flex items-center justify-between'>
            <div className='flex flex-1 flex-col-reverse items-start gap-y-2 sm:flex-row sm:items-center sm:space-x-2'>
                <Input
                    defaultValue={params.search || ""}
                    placeholder={t('search_adversaries')}
                    onChange={handleSearchChange}
                    className='h-8 w-[150px] lg:w-[250px]'
                />
                {/* Additional filters can be added here if needed, like client_type */}
            </div>
            <DataTableViewOptions table={table} />
        </div>
    )
}
